import { Control, useController } from 'react-hook-form';
import ErrorMessage from '@components/profile/profileOverlay/common/ErrorMessage';
import { AdditionInfoVO } from '@domain/vo/match/ResumeAdditionInfoVO';

import classnames from 'classnames/bind';
import styles from './additionalInputModal.module.scss';
const cx = classnames.bind(styles);

interface Props extends AdditionInfoVO {
  control: Control;
}

const Text = ({ additionInfoSn, question, required, maxAnswerSize, control }: Props) => {
  const {
    field,
    fieldState: { invalid },
    formState: { errors },
  } = useController({
    control,
    name: `${additionInfoSn}`,
  });

  return (
    <div>
      <h3 className={cx('formTitle')}>
        {question}
        {required && <span className={cx('require')}>필수</span>}
      </h3>
      <div className={cx('textareaWrap')}>
        <textarea
          placeholder="내용을 입력해주세요."
          maxLength={maxAnswerSize ?? 300}
          rows={4}
          className={cx({ error: invalid })}
          {...field}
        />
        <div className={cx('infoText', { error: invalid })}>
          {invalid ? (
            <ErrorMessage errors={errors} name={field.name} />
          ) : (
            <>
              최대 글자수 : <span className={cx('value')}>{(field.value ?? '').length}</span> / {maxAnswerSize ?? 300}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Text;
